import { useRef, useState } from "react";
import { Upload, Paperclip, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import FileUploader from "@/components/FileUploader";

// Customer account form attachments on the client dialog. New clients stage files; they upload after save.
export default function ClientAccountForm({ clientId, staged, setStaged }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const add = (list) => setStaged((s) => [...s, ...Array.from(list || []).map((file) => ({ file, name: file.name }))]);

  if (clientId) {
    return (
      <div className="md:col-span-2" data-testid="cli-account-form">
        <FileUploader entityType="client" entityId={`${clientId}__account_form`} label="Customer account form" showDocNumber />
      </div>
    );
  }
  return (
    <div className="md:col-span-2" data-testid="cli-account-form">
      <label className="text-xs text-slate-600">Customer account form</label>
      <div data-testid="cli-account-form-dropzone"
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); add(e.dataTransfer.files); }}
        className={`mt-1 flex flex-wrap items-center gap-2 rounded-sm border-2 border-dashed p-3 transition-colors ${drag ? "border-slate-900 bg-slate-100" : "border-slate-200 bg-slate-50/50"}`}>
        <Button type="button" variant="outline" size="sm" className="rounded-sm" onClick={() => inputRef.current?.click()} data-testid="cli-account-form-attach">
          <Upload className="h-3.5 w-3.5 mr-1.5" /> Attach file
        </Button>
        <span className="text-xs text-slate-500">or drag &amp; drop here — uploads when you save</span>
        <input ref={inputRef} type="file" multiple className="hidden" data-testid="cli-account-form-input"
          onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
        {staged.map((f, i) => (
          <span key={i} className="inline-flex items-center gap-1 text-xs border border-slate-200 rounded-sm pl-2 pr-1 py-0.5 bg-white" data-testid={`cli-account-form-staged-${i}`}>
            <Paperclip className="h-3 w-3 shrink-0" />
            <input value={f.name} title="Name this file" onChange={(e) => setStaged((s) => s.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))}
              className="w-44 bg-transparent outline-none border-b border-dashed border-slate-300 focus:border-slate-600" />
            <button type="button" onClick={() => setStaged((s) => s.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600"><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
    </div>
  );
}
